import { SupportIcon } from "@/shared/icons";
import { Button } from "@/shared/ui";

function AccountCharSupportTrigger({ onClick }: { onClick: () => void }) {
  return (
    <Button
      variant="soft"
      color="gray"
      className="h-10 px-4 flex items-center relative justify-between w-full normal-case text-15"
      onClick={onClick}
    >
      <div>Помощь</div>
      <SupportIcon size={16} />
    </Button>
  );
}

export default AccountCharSupportTrigger;
